import { useEffect, useState } from "react";
import useUser from "../../../hooks/useuser";
import useGradeBand from "./useGradeBand";

const grades = ["K", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];

export default function useGrade() {
  const { user } = useUser();
  const [grade, setGrade] = useState<string | undefined>(grades[user?.gradeLevel]);
  const gradeBands = useGradeBand(grade ?? "");

  useEffect(() => {
    if (user?.gradeLevel !== undefined) {
      setGrade(grades[user.gradeLevel]);
    }
  }, [user]);

  return { grade, ...gradeBands };
}
